// extracted by css-extract-rspack-plugin
export default {"delaySkeletonLoad":"issue-timeline-loading-module__delaySkeletonLoad__LuOlfhn","showAfterDelay":"issue-timeline-loading-module__showAfterDelay__SmBgk8E"};